import React from 'react';
export function EmotionalBlock() {
  return <section className="bg-white py-16 px-4 sm:px-6" data-id="element-84">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-85">
        <div className="text-6xl mb-6" data-id="element-86">🧠</div>

        <h2 className="font-archivo text-3xl sm:text-4xl md:text-5xl uppercase text-brand-black leading-tight" data-id="element-87">
          No necesitás ser maestra, terapeuta ni experta para estimular el
          desarrollo de tu hijo.
        </h2>

        <div className="text-lg sm:text-xl text-gray-700 font-medium space-y-6 max-w-2xl mx-auto" data-id="element-88">
          <p data-id="element-89">Muchas veces las familias sienten culpa porque:</p>

          <ul className="space-y-3 text-left max-w-md mx-auto bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-90">
            <li className="flex items-center gap-3" data-id="element-91">
              <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-92"></div>
              usan pantallas para entretener
            </li>
            <li className="flex items-center gap-3" data-id="element-93">
              <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-94"></div>
              no saben qué actividades hacer
            </li>
            <li className="flex items-center gap-3" data-id="element-95">
              <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-96"></div>
              no tienen tiempo para preparar juegos complicados
            </li>
            <li className="flex items-center gap-3" data-id="element-97">
              <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-98"></div>
              sienten que no están estimulando lo suficiente
            </li>
          </ul>

          <p className="font-bold text-2xl text-brand-black pt-4" data-id="element-99">
            Pero la realidad es otra.
          </p>

          <div className="bg-brand-yellow/20 p-6 rounded-xl border-2 border-brand-yellow" data-id="element-100">
            <p className="font-bold text-xl sm:text-2xl text-brand-black" data-id="element-101">
              👉 Los chicos aprenden muchísimo jugando con actividades simples,
              cotidianas y bien pensadas.
            </p>
          </div>

          <p className="font-archivo text-3xl uppercase text-brand-black pt-4" data-id="element-102">
            Por eso creamos "Crecer Jugando".
          </p>
        </div>
      </div>
    </section>;
}